import { memo } from 'react'
import { X } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/shared/components/ui/dialog'

interface TeamCommercialDialogAction {
  key: string
  label: string
  onClick: () => void
  tone?: 'primary' | 'secondary'
}

interface TeamCommercialDialogProps {
  actions: TeamCommercialDialogAction[]
  description: string
  onClose: () => void
  onOpenChange: (open: boolean) => void
  open: boolean
  title: string
}

export const TeamCommercialDialog = memo(function TeamCommercialDialog({
  actions,
  description,
  onClose,
  onOpenChange,
  open,
  title,
}: TeamCommercialDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        overlayClassName="z-[310]"
        className="z-[311] w-[420px] max-w-[calc(100vw-32px)] rounded-[16px] border border-[#494949] bg-[#292929] p-0 text-white shadow-[0px_4px_10px_0px_rgba(0,0,0,0.5)] [&>button]:hidden"
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <DialogDescription className="sr-only">{description}</DialogDescription>

        <div className="px-5 pb-5 pt-3">
          <div className="flex items-center justify-between">
            <div className="w-7" />
            <div className="text-center text-[14px] font-medium leading-5 text-[#EBEBEB]">
              {title}
            </div>
            <button
              type="button"
              className="flex h-7 w-7 items-center justify-center rounded-full text-white/44 transition hover:bg-white/8 hover:text-white/78"
              onClick={onClose}
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          <div className="mt-3 h-px rounded-full bg-black" />

          <div className="px-2 pb-2 pt-6 text-center text-[14px] leading-6 text-[#D0D0D0]">
            {description}
          </div>

          <div className={`mt-6 flex ${actions.length === 1 ? 'justify-center' : 'justify-center'} gap-4`}>
            {actions.map((action) => (
              <Button
                key={action.key}
                className={
                  action.tone === 'primary'
                    ? 'h-9 min-w-[140px] rounded-full border border-[#4096F3] bg-[#4096F3] px-5 text-[14px] font-medium text-white hover:bg-[#3D98F0]'
                    : 'h-9 min-w-[140px] rounded-full border border-[#383838] bg-[#383838] px-5 text-[14px] font-medium text-[#EBEBEB] hover:bg-[#424242]'
                }
                onClick={action.onClick}
                variant="secondary"
              >
                {action.label}
              </Button>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
})
